export const getBookRegistrationErrorMessage = (error: {
  status: number
  code?: number
  message?: string
}): string => {
  const { status, message } = error

  // 500 에러이고 메시지에 "ShelfEntry already exist"가 포함된 경우
  if (status === 409 && message?.includes("ShelfEntry already exist")) {
    return "이미 등록된 도서에요."
  }

  // 다른 에러 케이스들도 여기에 추가 가능
  switch (status) {
    case 422:
      return "올바르지 않은 ISBN 형식입니다."
    case 500:
      return "도서 등록 중 오류가 발생했습니다."
    default:
      return "서비스에 일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
  }
}
